import Feature1 from "../../../../src/sections/features/feature1.mdx";
import Feature2 from "../../../../src/sections/features/feature2.mdx";
import Feature3 from "../../../../src/sections/features/feature3.mdx";
import React from 'react';
export default {
  Feature1,
  Feature2,
  Feature3,
  React
};